import React from 'react';
import MenuGroupButton from './MenuGroupButton';
import RepeatingCirclesIcon from 'assets/icons/RepeatingCirclesIcon';
import { WorkbookToCGrouping } from 'types';
import { makeStyles } from '@mui/styles';

type Props = {
  activeGroup: string;
  content: WorkbookToCGrouping[];
  handleTOCGroupChange: (groupName: string) => () => void;
};

const useStyles = makeStyles(() => ({
  sectionTabs: {
    gridArea: 'header',
    alignSelf: 'center',
    margin: `0 auto`,
    width: '100%'
  }
}));

const MenuGroupTabs = ({ activeGroup, content, handleTOCGroupChange }: Props) => {
  const classes = useStyles();
  return (
    <div className={classes.sectionTabs}>
      {content?.map((section, i) => {
        return (section.categories && section.categories.length > 0) ||
          (section.characters && section.characters.length > 0) ? (
          <MenuGroupButton
            isActive={activeGroup === section.grouping}
            key={i}
            onClick={handleTOCGroupChange(section.grouping)}
            name={section.grouping}
          />
        ) : null;
      })}
      <MenuGroupButton
        isActive={activeGroup === 'search'}
        onClick={handleTOCGroupChange('search')}
        icon={RepeatingCirclesIcon}
        name={'search'}
        iconSize={'28px'}
      />
    </div>
  );
};

export default MenuGroupTabs;
